import { createAction } from 'redux-actions';

export const logMesssage = createAction<string>('[Logging] Log Message');
